import firebase from "../firebase";

import {Tenant} from "./types";

export default {
  update: (tenant: Tenant) => firebase.database.collection("tenants").doc(tenant.id).update(tenant),
  fetch: (slug: Tenant["slug"]) =>
    firebase.database
      .collection("tenants")
      .where("slug", "==", slug)
      .limit(1)
      .get()
      .then((snapshot) =>
        snapshot.empty ? Promise.reject("La tienda no existe") : snapshot.docs[0],
      )
      .then((doc) => ({id: doc.id, ...(doc.data() as Tenant)})),
};
